/**
 * <pickup-availability> - shows whether the selected variant can be picked up
 * locally. The markup comes from sections/pickup-availability.liquid, fetched
 * through the Section Rendering API for the current variant and re-fetched
 * whenever the surrounding <product-page> reports a `variant:change`.
 * Stays hidden when the variant is sold out or no location offers pickup.
 */
if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      connectedCallback() {
        this.requestId = 0;
        this.productPage = this.closest('product-page');

        this.onVariantChange = (event) => {
          const variant = event.detail && event.detail.variant;
          if (!variant) return;
          this.load(variant.available ? variant.id : null);
        };
        if (this.productPage) this.productPage.addEventListener('variant:change', this.onVariantChange);

        this.addEventListener('click', (event) => {
          const dialog = this.querySelector('[data-pickup-availability-dialog]');
          if (!dialog) return;
          if (event.target.closest('[data-pickup-availability-open]')) dialog.showModal();
          if (event.target.closest('[data-pickup-availability-close]') || event.target === dialog) dialog.close();
        });

        this.load(this.hasAttribute('data-unavailable') ? null : this.dataset.variantId);
      }

      disconnectedCallback() {
        if (this.productPage) this.productPage.removeEventListener('variant:change', this.onVariantChange);
      }

      clear() {
        this.innerHTML = '';
        this.hidden = true;
      }

      load(variantId) {
        const requestId = ++this.requestId;
        if (!variantId) {
          this.clear();
          return;
        }

        const root = (this.dataset.rootUrl || '/').replace(/\/?$/, '/');
        fetch(`${root}variants/${variantId}/?section_id=pickup-availability`)
          .then((response) => (response.ok ? response.text() : ''))
          .then((text) => {
            // A newer variant was selected while this request was in flight.
            if (requestId !== this.requestId) return;
            const content = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('[data-pickup-availability-content]');
            if (!content || !content.innerHTML.trim()) {
              this.clear();
              return;
            }
            this.innerHTML = content.innerHTML;
            this.hidden = false;
          })
          .catch(() => {
            if (requestId === this.requestId) this.clear();
          });
      }
    }
  );
}
